import { build } from './build';
import { parse } from './parse';
import type { ParseOptions } from './types';

/**
 * The canonical path form of a product-discovery URL: a {@link parse} &rarr;
 * {@link build} round-trip. Drops query/fragment, re-sorts and re-encodes filter
 * pairs and multi-select values, fills interior skipped taxonomy levels with
 * `all` and trims trailing ones — so two URLs denoting the same selection
 * produce the same string. Casing is preserved (see {@link encodeValue}); a
 * case-insensitive match key is the caller's `.toLowerCase()` of this result.
 *
 * The single notion of URL identity for the scheme: equality is
 * `canonicalPath(a) === canonicalPath(b)`, and it is also the canonical href to
 * emit (e.g. in a `<link rel="canonical">`).
 *
 * @throws {RouteParseError} if `url` cannot be parsed under `options`.
 */
export const canonicalPath = (url: string, options: ParseOptions): string =>
  build({
    basePath: options.basePath,
    filters: parse(url, options),
    taxonomyAliases: options.taxonomyAliases,
  });
